import { createGlobalStyle } from "styled-components";
import { getGoogleFonts } from "./StyleFactory/utilities";
import { DynamicStructureType } from "./DynamicFactory";

const GlobalStyle = createGlobalStyle<{ structure: DynamicStructureType }>`
  ${({ structure }) =>
    getGoogleFonts(structure)?.map((font) => `@import url(${font});`)}
`;

export default GlobalStyle;
